'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputAddon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isBoolean2 = require('lodash/isBoolean');

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  min-width: 40px;\n  height: 40px;\n  flex-flow: column;\n  text-align: center;\n\n  ', ';\n'], ['\n  min-width: 40px;\n  height: 40px;\n  flex-flow: column;\n  text-align: center;\n\n  ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      color: ', ';\n      border: 1px solid #dfe2e4;\n      padding: 0 16px;\n\n      ', ';\n      ', ';\n    '], ['\n      background-color: ', ';\n      color: ', ';\n      border: 1px solid #dfe2e4;\n      padding: 0 16px;\n\n      ', ';\n      ', ';\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n          border-right: 0;\n          border-radius: ', ' 0 0\n            ', ';\n        '], ['\n          border-right: 0;\n          border-radius: ', ' 0 0\n            ', ';\n        ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n          border-left: 0;\n          border-radius: 0 ', '\n            ', ' 0;\n        '], ['\n          border-left: 0;\n          border-radius: 0 ', '\n            ', ' 0;\n        ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 16px;\n  font-weight: ', ';\n  transition: background-color, border-color 160ms linear;\n  user-select: text;\n  width: 100%;\n'], ['\n  font-size: 16px;\n  font-weight: ', ';\n  transition: background-color, border-color 160ms linear;\n  user-select: text;\n  width: 100%;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  min-width: 0;\n  color: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:-webkit-autofill {\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:read-only {\n    background-color: ', ';\n    border: ', ';\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ' ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  min-width: 0;\n  color: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:-webkit-autofill {\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:read-only {\n    background-color: ', ';\n    border: ', ';\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ' ', ';\n\n  ', ';\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: #fff;\n      border-radius: ', ';\n      border: ', ';\n      padding: 4px 8px 4px 16px;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n\n      ', ';\n      ', ';\n    '], ['\n      background-color: #fff;\n      border-radius: ', ';\n      border: ', ';\n      padding: 4px 8px 4px 16px;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n\n      ', ';\n      ', ';\n    ']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        '], ['\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        ']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        '], ['\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        ']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n      background: transparent;\n      border: 0;\n      padding: 4px 0;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:disabled,\n      &:read-only {\n        background-color: transparent;\n        border: 0;\n      }\n    '], ['\n      background: transparent;\n      border: 0;\n      padding: 4px 0;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:disabled,\n      &:read-only {\n        background-color: transparent;\n        border: 0;\n      }\n    ']),
    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n      border: 1px solid ', ';\n      padding: 7px 10px;\n    '], ['\n      border: 1px solid ', ';\n      padding: 7px 10px;\n    ']),
    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['\n        border-color: ', '!important;\n      '], ['\n        border-color: ', '!important;\n      ']),
    _templateObject13 = (0, _taggedTemplateLiteral3.default)(['\n      border-color: ', '!important;\n    '], ['\n      border-color: ', '!important;\n    ']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _react2 = require('../../utils/react');

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _layout = require('../layout');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EXPANDS_BUFFER = 5;

var INPUT_SIZE_MAP = {
  small: {
    fontSize: 14,
    size: 32
  },
  medium: {
    fontSize: 14,
    size: 40
  },
  large: {
    fontSize: 16,
    size: 48
  }
};

var getInputFont = function getInputFont(size) {
  return 'normal ' + INPUT_SIZE_MAP[size].fontSize + 'px WebFaktSoftPro';
};

var StyledInputAddon = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Flex)(_templateObject, function (props) {
  return props.inputTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.grey300, props.theme.colors.navy600, props.addonType === 'prefix' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3, props.theme.layout.borderRadiusInput, props.theme.layout.borderRadiusInput), props.addonType === 'suffix' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4, props.theme.layout.borderRadiusInput, props.theme.layout.borderRadiusInput));
});

var InputAddon = exports.InputAddon = function InputAddon(props) {
  return React.createElement(
    StyledInputAddon,
    {
      justifyContent: 'center',
      alignItems: 'center',
      addonType: props.type,
      inputTheme: props.inputTheme
    },
    (0, _isString3.default)(props.content) ? React.createElement(
      _text2.default,
      { size: 'small', color: 'slate', weight: 'semi-bold' },
      props.content
    ) : props.content
  );
};

var StyledInputContainer = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Flex)(_templateObject5, function (props) {
  return props.theme.typography.fontWeightNormal;
});

var StyledInput = /*#__PURE__*/(0, _reactEmotion2.default)('input')(_templateObject6, function (props) {
  return props.theme.colors.navy700;
}, function (props) {
  return INPUT_SIZE_MAP[props.size].fontSize;
}, function (props) {
  return INPUT_SIZE_MAP[props.size].size;
}, function (props) {
  return props.theme.input.inputDisabledBackground;
}, function (props) {
  return props.theme.input.inputDisabledBorder;
}, function (props) {
  return props.theme.input.inputDisabledColor;
}, function (props) {
  return props.theme.input.inputReadonlyBackground;
}, function (props) {
  return props.theme.input.inputReadonlyBorder;
}, function (props) {
  return props.theme.input.inputReadonlyColor;
}, function (props) {
  return props.inputTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject7, props.theme.input.inputBorderRadius, props.theme.input.inputDefaultBorder, props.theme.colors.grey500, props.theme.input.inputHoverBorder, props.theme.input.inputActiveBorder, props.withAddonPrefix && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject8), props.withAddonSuffix && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject9));
}, function (props) {
  return props.inputTheme === 'transparent' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject10, props.theme.colors.navy500);
}, function (props) {
  return props.inputTheme === 'well' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject11, props.theme.colors.grey500);
}, function (props) {
  return props.valid && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject12, props.theme.colors.green500);
}, function (props) {
  return props.invalid && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject13, props.theme.colors.pink500);
});

var Input = function (_PureComponent) {
  (0, _inherits3.default)(Input, _PureComponent);

  function Input(props) {
    (0, _classCallCheck3.default)(this, Input);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.state = { focused: false, changed: false };

    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Input, [{
    key: 'onFocus',
    value: function onFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);

        this.setState({ focused: true });
      }

      if (this.props.readonly) {
        event.preventDefault();
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }

      if (this.props.readonly) {
        event.preventDefault();
        return;
      }

      this.setState({ focused: false });

      if (this.state.changed && this.props.onEdited) {
        this.props.onEdited(event);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event);
      }
      this.setState({ changed: true });
    }

    /**
     * If we are presenting an extendable input field we need to know what width
     * our input should have, this will depend on the width of the text currently
     * entered as well as the font. We use canvas to measure this value.
     */

  }, {
    key: 'getTextWidth',
    value: function getTextWidth(text, font) {
      this.canvas = this.canvas ? this.canvas : document.createElement('canvas');
      var context = this.canvas.getContext('2d');
      if (context) {
        context.font = font;
        return context.measureText(text).width;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          margin = _props.margin,
          size = _props.size,
          fullWidth = _props.fullWidth,
          defaultValue = _props.defaultValue,
          value = _props.value,
          style = _props.style,
          className = _props.className,
          expands = _props.expands,
          focusOnMount = _props.focusOnMount,
          _IGNORED = _props.onEdited,
          __IGNORED = _props.editable,
          placeholder = _props.placeholder,
          valid = _props.valid,
          readonly = _props.readonly,
          name = _props.name,
          inputRef = _props.inputRef,
          addonPrefix = _props.addonPrefix,
          addonSuffix = _props.addonSuffix,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['theme', 'margin', 'size', 'fullWidth', 'defaultValue', 'value', 'style', 'className', 'expands', 'focusOnMount', 'onEdited', 'editable', 'placeholder', 'valid', 'readonly', 'name', 'inputRef', 'addonPrefix', 'addonSuffix']);
      var focused = this.state.focused;


      var _styles = (0, _extends3.default)({}, style, {
        width: expands ? Math.max(this.getTextWidth(value, getInputFont(size)) + EXPANDS_BUFFER, this.getTextWidth(placeholder, getInputFont(size)) + EXPANDS_BUFFER) : undefined
      });

      return React.createElement(
        StyledInputContainer,
        { marginBottom: margin, className: className },
        addonPrefix ? React.createElement(InputAddon, { inputTheme: theme, content: addonPrefix, type: 'prefix' }) : null,
        React.createElement(StyledInput, (0, _extends3.default)({}, otherProps, {
          /** Emotion Props */
          inputTheme: theme,
          expands: expands,
          valid: (0, _isBoolean3.default)(valid) && valid,
          invalid: (0, _isBoolean3.default)(valid) && !valid,
          focused: focused,
          margin: margin,
          fullWidth: fullWidth,
          size: size,
          withAddonPrefix: !!addonPrefix,
          withAddonSuffix: !!addonSuffix
          /** Other Props */
          , ref: focusOnMount ? _react2.focusOnMount : inputRef,
          style: _styles,
          className: className,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onChange: readonly ? undefined : this.onChange,
          placeholder: placeholder,
          name: !!name ? name : placeholder,
          value: value,
          defaultValue: defaultValue,
          readOnly: readonly
        })),
        addonSuffix ? React.createElement(InputAddon, { inputTheme: theme, content: addonSuffix, type: 'suffix' }) : null
      );
    }
  }]);
  return Input;
}(_component2.default);

Input.defaultProps = {
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onEdited: function onEdited() {},
  theme: 'default',
  margin: 'none',
  size: 'medium'
};
exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/input/input.js
// module id = 339
// module chunks = 114276838955818